/**
 * Created by jordid on 28/10/15-
 * @module ma-event
 */

const MAEvent = {
    mapFeatureInfoWindowOpened: 'ma-maps-featureInfoWindowOpened',
    mapFeatureInfoWindowClosing: 'ma-maps-featureInfoWindowClosing',

    mapReady: 'ma-maps-ready',
    mapExpanded: 'ma-maps-expanded',
    mapReduced: 'ma-maps-reduced',
    mapFeatureTypeAdded: 'ma-maps-featureTypeAdded',
    mapFeatureTypeRemoved: 'ma-maps-featureTypeRemoved',
    mapFeaturesLayerWillShow: 'ma-maps-featuresLayerWillShow',
    mapFeaturesLayerDidShow: 'ma-maps-featuresLayerDidShow',
    mapFeaturesLayerWillHide: 'ma-maps-featuresLayerWillHide',
    mapFeaturesLayerDidHide: 'ma-maps-featuresLayerDidHide',
    mapFeaturesLayerRegistered: 'ma-maps-featuresLayerRegistered',
    mapFeaturesLayerChanged: 'ma-maps-featuresLayerChanged',
    mapPricesLayerRegistered: 'ma-maps-pricesLayerRegistered',
    mapPricesLayerWillShow: 'ma-maps-pricesLayerWillShow',
    mapPricesLayerChanged: 'ma-maps-pricesLayerChanged',
    mapPricesLayerDidShow: 'ma-maps-pricesLayerDidShow',
    mapPricesLayerDidHide: 'ma-maps-pricesLayerDidHide',
    mapPricesNavigationChanged: 'ma-maps-pricesNavigationChanged',
    mapPricesPlaceChanged: 'ma-maps-pricesPlaceChanged',
    mapReferencePopinOpened: 'ma-maps-referencePopinOpened',
    mapSettingsPopinOpened: 'ma-maps-settingsPopinOpened',

    pricesPlaceDidChange: 'ma-prices-placeDidChange',
    pricesPlaceWillChange: 'ma-prices-placeWillChange',
    pricesPlaceClicked: 'ma-prices-placeClicked',

    mapLayerChanged: 'ma-maps-layerChanged',
    mapPlaceClicked: 'ma-maps-mapPlaceClicked',

    navigationSectionOpened: 'ma-navigation-sectionOpened',
    navigationSectionClosed: 'ma-navigation-sectionClosed',

    formStarted: 'ma-form-started',
    formSubmitAttempt: 'ma-form-submitAttempt',
    formSubmitSuccess: 'ma-form-submitSuccess',
    formSubmitError: 'ma-form-submitError',
    formPendingStateChange: 'ma-form-pendingStateChange',

    transitLineShow: 'ma-transitLineShow',

    placeSelected: 'ma-form-placeSelected',
    searchFiltersPlaceTagsUpdated: 'ma-form-searchFiltersPlaceTagsUpdated',
    realtorSelected: 'ma-form-realtorSelected',
};

export default MAEvent;
